import { render, staticRenderFns } from "./SlotsCanvas.vue?vue&type=template&id=bdd3aca8"
import script from "./SlotsCanvas.vue?vue&type=script&lang=js"
export * from "./SlotsCanvas.vue?vue&type=script&lang=js"
import style0 from "./SlotsCanvas.vue?vue&type=style&index=0&id=bdd3aca8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports